import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';

const services = [
  {
    icon: '🎬',
    title: 'أفلام متنوعة',
    desc: 'مكتبة ضخمة من الأفلام العربية والعالمية بجودة HD، متاحة للمشاهدة الفورية عبر الشبكة المحلية دون أي تأخير.',
  },
  {
    icon: '📺',
    title: 'مسلسلات حصرية',
    desc: 'تابع أحدث المسلسلات العربية والأجنبية بجميع حلقاتها المتاحة، مع تحديثات دورية لإضافة محتوى جديد.',
  },
  {
    icon: '🎙️',
    title: 'بودكاست مباشر',
    desc: 'استمع وشاهد جلسات البودكاست المباشرة والمسجلة في مجالات متعددة كالترفيه والتقنية والثقافة.',
  },
  {
    icon: '🖥️',
    title: 'لوحة تحكم متقدمة',
    desc: 'أدوات إدارة شاملة لمزودي الشبكة تتيح التحكم في المحتوى والمستخدمين وتحليل الإحصاءات بكل سهولة.',
  },
  {
    icon: '📱',
    title: 'تطبيق موبايل',
    desc: 'تطبيق أنيق وسريع لأجهزة iOS وAndroid يمنح المستخدمين تجربة مشاهدة مريحة من أي مكان داخل نطاق الشبكة.',
  },
  {
    icon: '📡',
    title: 'شبكة محلية ذكية',
    desc: 'تقنية متطورة تضمن سرعة بث عالية وجودة صورة ممتازة داخل نطاق الشبكة المحلية المغلقة دون الحاجة للإنترنت.',
  },
];

const steps = [
  {
    number: '01',
    icon: '📡',
    title: 'الاتصال بالشبكة المحلية',
    desc: 'يتصل المستخدم بشبكة واي فاي  المحلية الخاصة بالمنشأة (فندق، مستشفى، مقهى) دون الحاجة لأي بيانات إنترنت.',
  },
  {
    number: '02',
    icon: '🌐',
    title: 'فتح الاستراحة تلقائياً',
    desc: 'تظهر استراحة استراحة شاشتنا  تلقائياً في المتصفح، أو يمكن فتح التطبيق مباشرة والبدء في تصفح المحتوى.',
  },
  {
    number: '03',
    icon: '🍿',
    title: 'استمتع بالمحتوى',
    desc: 'شاهد أفلامك ومسلسلاتك المفضلة أو استمع إلى البودكاست بجودة عالية وبدون انقطاع.',
  },
];

const products = [
  {
    tag: 'تطبيق ويب',
    tagClass: 'product-tag-web',
    icon: '🌐',
    title: 'تطبيق الويب',
    desc: 'تجربة مشاهدة غنية عبر المتصفح دون تثبيت أي برنامج، تعمل على جميع الأجهزة والأنظمة.',
    features: [
      'يعمل على جميع المتصفحات الحديثة',
      'واجهة مستخدم سلسة وسريعة الاستجابة',
      'دعم دقة 4K وجودة صوت متميزة',
      'قوائم تشغيل وإشارات مرجعية',
    ],
    gradient: 'linear-gradient(135deg, rgba(139,92,246,0.2) 0%, rgba(6,182,212,0.1) 100%)',
  },
  {
    tag: 'تطبيق موبايل',
    tagClass: 'product-tag-mobile',
    icon: '📱',
    title: 'تطبيق الجوال',
    desc: 'تطبيق أصلي متاح لنظامي iOS وAndroid مع واجهة محسّنة للشاشات اللمسية وتجربة مستخدم فائقة.',
    features: [
      'متاح على App Store و Google Play',
      'وضع عرض أفقي وعمودي',
      'إشعارات فورية للمحتوى الجديد',
      'واجهة محسّنة للشاشات اللمسية',
    ],
    gradient: 'linear-gradient(135deg, rgba(6,182,212,0.2) 0%, rgba(16,185,129,0.1) 100%)',
  },
  {
    tag: 'لوحة الإدارة',
    tagClass: 'product-tag-admin',
    icon: '⚙️',
    title: 'لوحة التحكم',
    desc: 'استراحة إدارية متكاملة تمنح مزودي الشبكة المحلية تحكماً كاملاً في المحتوى والمستخدمين والإحصاءات.',
    features: [
      'إدارة المحتوى والتحميلات',
      'تحليلات وإحصاءات تفصيلية',
      'إدارة المستخدمين والصلاحيات',
      'تخصيص الواجهة حسب المنشأة',
    ],
    gradient: 'linear-gradient(135deg, rgba(245,158,11,0.2) 0%, rgba(239,68,68,0.1) 100%)',
  },
];

function Home() {
  return (
    <>
      {/* Hero */}
      <Hero />

      {/* Stats Bar */}
      <div className="divider" />
      <section style={{
        background: 'var(--bg-secondary)',
        padding: 'var(--spacing-2xl) 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="dot-pattern" style={{ opacity: 0.5 }} />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="stats-bar">
            {[
              { number: '+500', label: 'فيلم ومسلسل متاح', icon: '🎬' },
              { number: '+50K', label: 'مستخدم نشط شهرياً', icon: '👥' },
              { number: '+200', label: 'مزود شبكة محلية', icon: '📡' },
              { number: '24/7', label: 'دعم فني متواصل', icon: '🛟' },
            ].map((stat) => (
              <div className="stat-item" key={stat.label}>
                <div style={{ fontSize: '1.5rem', marginBottom: '4px' }}>{stat.icon}</div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="divider" />

      {/* Services Section */}
      <section className="section">
        <div className="bg-blobs" style={{ opacity: 0.5 }}>
          <div className="blob blob-1" style={{ width: '300px', height: '300px' }} />
          <div className="blob blob-2" style={{ width: '250px', height: '250px' }} />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            خدماتنا{' '}
            <span className="gradient-text">المتكاملة</span>
          </h2>
          <p className="section-subtitle">
            نقدم منظومة ترفيهية متكاملة تشمل جميع احتياجاتك من محتوى ومنصات وأدوات إدارة،
            كل ذلك عبر شبكتك المحلية دون الحاجة للإنترنت الخارجي.
          </p>
          <div className="services-grid">
            {services.map((service) => (
              <div className="service-card" key={service.title}>
                <span className="service-icon">{service.icon}</span>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-desc">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* How It Works Section */}
      <section className="section section-alt">
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            كيف{' '}
            <span className="gradient-text">يعمل النظام؟</span>
          </h2>
          <p className="section-subtitle">
            ثلاث خطوات بسيطة تفصلك عن تجربة ترفيهية لا مثيل لها، دون تعقيد أو إعداد مسبق.
          </p>
          <div className="steps-container">
            {steps.map((step, index) => (
              <div className="step-card" key={index}>
                <div className="step-number">{step.number}</div>
                <span className="step-icon">{step.icon}</span>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-desc">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Products Showcase Section */}
      <section className="section">
        <div className="bg-blobs" style={{ opacity: 0.4 }}>
          <div className="blob blob-2" style={{ width: '400px', height: '400px', top: '10%', right: '-150px' }} />
          <div className="blob blob-3" style={{ width: '300px', height: '300px', bottom: '10%', left: '-100px' }} />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            منتجاتنا{' '}
            <span className="gradient-text">الثلاثة</span>
          </h2>
          <p className="section-subtitle">
            نوفر ثلاث منصات متكاملة تلبي احتياجات جميع المستخدمين، من المشاهد العادي
            إلى مدير الشبكة المحلية.
          </p>
          <div className="products-grid">
            {products.map((product) => (
              <div className="product-card" key={product.title}>
                <div
                  className="product-card-bg"
                  style={{ background: product.gradient }}
                >
                  <div
                    className="product-card-icon-wrap"
                    style={{
                      background: 'rgba(255,255,255,0.05)',
                      border: '1px solid rgba(255,255,255,0.1)',
                    }}
                  >
                    <span style={{ fontSize: '2.2rem' }}>{product.icon}</span>
                  </div>
                  <span className={`product-tag ${product.tagClass}`}>
                    {product.tag}
                  </span>
                  <h3 className="product-title">{product.title}</h3>
                  <p className="product-desc">{product.desc}</p>
                  <div className="product-features">
                    {product.features.map((feature) => (
                      <div className="product-feature" key={feature}>
                        <span className="product-feature-dot" />
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* CTA Banner */}
      <section className="cta-banner section-alt">
        <div className="bg-blobs" style={{ opacity: 0.3 }}>
          <div className="blob blob-1" />
          <div className="blob blob-2" />
        </div>
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="cta-banner-inner">
            <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-lg)' }}>🚀</div>
            <h2 className="cta-banner-title">
              هل أنت مستعد لتحويل{' '}
              <span className="gradient-text">تجربة ضيوفك؟</span>
            </h2>
            <p className="cta-banner-subtitle">
              انضم إلى أكثر من 200 مزود شبكة محلية يستخدمون استراحة شاشتنا  لتقديم
              تجربة ترفيهية استثنائية لضيوفهم ومستخدميهم.
            </p>
            <div className="cta-buttons">
              <Link to="/support" className="btn-primary">
                <span>💬</span>
                <span>تواصل معنا الآن</span>
              </Link>
              <Link to="/about" className="btn-outline">
                <span>📖</span>
                <span>اعرف المزيد عنّا</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;